import { TableCell, TableRow, Typography, styled } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1.5),
}));

export const HeaderTypography = styled(Typography)(() => ({
    lineHeight: 1,
}));
